var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("video", {
    staticStyle: { "object-fit": "fill" },
    attrs: {
      id: "player-container-id",
      "webkit-playsinline": "",
      playsinline: "",
      "x5-video-player-type": "h5",
      "x5-video-player-fullscreen": "false",
      allowfullscreen: "false",
      webkitallowfullscreen: "false",
      mozallowfullscreen: "false",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }